<dialog class="modal" [open]="open">
  <div class="modal-box paper-modal max-w-3xl">
    <h3 class="h2 mb-1 flex items-center gap-2">
      <span class="text-primary">⚙️</span> Benutzerverwaltung
    </h3>
    <p class="opacity-80 mb-4">
      Im Heimnetz ist KnuffelBoard ohne Anmeldung nutzbar. Von außerhalb ist eine
      Anmeldung mit einem dieser Benutzer erforderlich.
    </p>

    @if (notice()) {
      <div class="alert alert-success mb-3">
        <span>{{ notice() }}</span>
      </div>
    }
    @if (error()) {
      <div class="alert alert-error mb-3">
        <span>{{ error() }}</span>
      </div>
    }

    <!-- Liste -->
    @if (!isEditing) {
      <div class="overflow-x-auto max-h-[55vh]">
        <table class="table table-sm">
          <thead>
            <tr>
              <th>Anzeigename</th>
              <th>Benutzername</th>
              <th>Rolle</th>
              <th>Letzter Login</th>
              <th class="text-right">Aktion</th>
            </tr>
          </thead>
          <tbody>
            @for (u of users(); track u) {
              <tr>
                <td class="font-semibold">
                  {{ u.displayName }}
                  @if (currentUser()?.id === u.id) {
                    <span class="badge badge-ghost badge-sm ml-1">du</span>
                  }
                </td>
                <td class="opacity-80">{{ u.username }}</td>
                <td>
                  @if (u.isAdmin) {
                    <span class="badge badge-primary badge-sm">Administrator</span>
                  }
                  @if (!u.isAdmin) {
                    <span class="badge badge-ghost badge-sm">Spieler</span>
                  }
                </td>
                <td class="opacity-70">
                  {{ u.lastLoginAt ? (u.lastLoginAt | date:'dd.MM.yyyy HH:mm') : 'noch nie' }}
                </td>
                <td class="text-right whitespace-nowrap">
                  <button class="btn btn-xs btn-ghost" (click)="startEdit(u)" [disabled]="busy()">
                    Bearbeiten
                  </button>
                  <button class="btn btn-xs btn-ghost text-error" (click)="askDelete(u)" [disabled]="busy()">
                    Löschen
                  </button>
                </td>
              </tr>
              @if (confirmDeleteId() === u.id) {
                <tr>
                  <td colspan="5">
                    <div class="alert alert-warning flex flex-col sm:flex-row sm:items-center gap-3">
                      <span class="flex-1">
                        Benutzer „{{ u.displayName }}“ wirklich löschen? Damit werden auch alle
                        offenen Anmeldungen dieses Benutzers ungültig.
                      </span>
                      <span class="flex gap-2">
                        <button class="btn btn-sm btn-error" (click)="confirmDelete(u)" [disabled]="busy()">
                          Endgültig löschen
                        </button>
                        <button class="btn btn-sm btn-ghost" (click)="cancelDelete()" [disabled]="busy()">
                          Abbrechen
                        </button>
                      </span>
                    </div>
                  </td>
                </tr>
              }
            }
            @if (!loading() && users().length === 0) {
              <tr>
                <td colspan="5" class="opacity-70">
                  Noch kein Benutzer angelegt. Solange das so ist, ist kein Zugriff von
                  außerhalb des Heimnetzes möglich.
                </td>
              </tr>
            }
            @if (loading()) {
              <tr>
                <td colspan="5" class="opacity-70">
                  <span class="loading loading-spinner loading-sm align-middle"></span> Lade Benutzer…
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
      <div class="modal-action justify-between">
        <button class="btn btn-primary" (click)="startCreate()" [disabled]="busy()">
          Benutzer anlegen
        </button>
        <button class="btn" (click)="close()">Schließen</button>
      </div>
    }

    <!-- Anlegen / Bearbeiten -->
    @if (draft(); as d) {
      <form (ngSubmit)="save()">
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div class="form-control">
            <label class="label"><span class="label-text">Benutzername</span></label>
            <input
              [(ngModel)]="d.username"
              name="username"
              autocomplete="off"
              class="input input-bordered"
              placeholder="z.B. papa"
              [disabled]="busy() || d.id !== null" />
            <label class="label">
              <span class="label-text-alt opacity-70">
                {{ d.id !== null
                ? 'Der Benutzername kann nicht geändert werden.'
                : '3–32 Zeichen: Buchstaben, Ziffern, . - _' }}
              </span>
            </label>
          </div>
          <div class="form-control">
            <label class="label"><span class="label-text">Anzeigename</span></label>
            <input
              [(ngModel)]="d.displayName"
              name="displayName"
              autocomplete="off"
              class="input input-bordered"
              placeholder="z.B. Papa"
              [disabled]="busy()" />
          </div>
          <div class="form-control md:col-span-2">
            <label class="label">
              <span class="label-text">
                {{ d.id !== null ? 'Neues Kennwort' : 'Kennwort' }}
              </span>
            </label>
            <input
              [(ngModel)]="d.password"
              name="password"
              type="password"
              autocomplete="new-password"
              class="input input-bordered"
              [placeholder]="d.id !== null ? 'Leer lassen, um das Kennwort beizubehalten' : 'Mindestens 8 Zeichen'"
              [disabled]="busy()" />
            <label class="label">
              <span class="label-text-alt opacity-70">
                Mindestens 8 Zeichen. Kennwörter werden nur als Hash gespeichert.
              </span>
            </label>
          </div>
        </div>
        <label class="label cursor-pointer justify-start gap-3 mt-1">
          <input
            type="checkbox"
            [(ngModel)]="d.isAdmin"
            name="isAdmin"
            class="checkbox checkbox-primary"
            [disabled]="busy() || forcedAdmin()" />
          <span class="label-text">
            Administrator – darf die Benutzerverwaltung auch von außerhalb öffnen
          </span>
        </label>
        @if (forcedAdmin()) {
          <p class="text-sm opacity-70 mt-1">
            Der erste Benutzer wird automatisch Administrator.
          </p>
        }
        @if (error()) {
          <div class="alert alert-error mt-3">
            <span>{{ error() }}</span>
          </div>
        }
        <div class="modal-action">
          <button type="button" class="btn btn-ghost" (click)="cancelEdit()" [disabled]="busy()">
            Abbrechen
          </button>
          <button type="submit" class="btn btn-primary" [disabled]="busy()">
            @if (busy()) {
              <span class="loading loading-spinner loading-sm"></span>
            }
            Speichern
          </button>
        </div>
      </form>
    }
  </div>
</dialog>
